/**
 * @generated SignedSource<<a95e4193e33eb548e06ff3e24fac5941>>
 * @relayHash eeb2671b330f442175b5b170ebb46ee9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dcde260be0e124742180f190da832be49297f0cd9b1f1463f76ece6a5cd49129

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalAccessPermissionsSettingsAggQuery$variables = {
  containerId: string;
  isDefaultAccessLevelEnabled: boolean;
  isM3GroupPermsEnabled: boolean;
};
export type GoalAccessPermissionsSettingsAggQuery$data = {
  readonly DefaultGoalAccessLevelSection?: {
    readonly " $fragmentSpreads": FragmentRefs<"DefaultGoalAccessLevelSection">;
  } | null;
  readonly GoalGroupPermissionsSettings?: {
    readonly " $fragmentSpreads": FragmentRefs<"GoalGroupPermissionsSettings">;
  } | null;
};
export type GoalAccessPermissionsSettingsAggQuery = {
  response: GoalAccessPermissionsSettingsAggQuery$data;
  variables: GoalAccessPermissionsSettingsAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDefaultAccessLevelEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isM3GroupPermsEnabled"
},
v3 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalAccessPermissionsSettingsAggQuery",
    "selections": [
      {
        "condition": "isDefaultAccessLevelEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v4/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "DefaultGoalAccessLevelSection"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "DefaultGoalAccessLevelSection"
          }
        ]
      },
      {
        "condition": "isM3GroupPermsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v4/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "GoalGroupPermissionsSettings"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "GoalGroupPermissionsSettings"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalAccessPermissionsSettingsAggQuery",
    "selections": [
      {
        "condition": "isDefaultAccessLevelEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "TownsquareGoalsAppSettings",
            "kind": "LinkedField",
            "name": "goals_appSettings",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "defaultGoalAccessLevel"
              }
            ]
          }
        ]
      },
      {
        "condition": "isM3GroupPermsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "TownsquareGoalAppCapabilities",
            "kind": "LinkedField",
            "name": "goals_capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canRemoveAppLevelPermissions"
              }
            ]
          },
          {
            "args": [
              (v3/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 100
              }
            ],
            "concreteType": "TownsquareGoalsAppPermissionPolicyConnection",
            "kind": "LinkedField",
            "name": "goals_appPermissionPolicies",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalsAppPermissionPolicyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalsAppPermissionPolicy",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "scopedGroupId"
                      },
                      {
                        "concreteType": "IdentityGroup",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isDefaultGroup"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isEditable"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "userCount"
                      },
                      {
                        "concreteType": "TownsquareProductRole",
                        "kind": "LinkedField",
                        "name": "productRoles",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "role"
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoalsAppPermissionEntry",
                        "kind": "LinkedField",
                        "name": "appPermissions",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "permission"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isPermitted"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "eeb2671b330f442175b5b170ebb46ee9",
    "id": "dcde260be0e124742180f190da832be49297f0cd9b1f1463f76ece6a5cd49129",
    "metadata": {},
    "name": "GoalAccessPermissionsSettingsAggQuery",
    "operationKind": "query",
    "text": "query GoalAccessPermissionsSettingsAggQuery(\n  $containerId: ID!\n  $isM3GroupPermsEnabled: Boolean!\n  $isDefaultAccessLevelEnabled: Boolean!\n) {\n  ...DefaultGoalAccessLevelSection_1GKbF9 @include(if: $isDefaultAccessLevelEnabled)\n  ...GoalGroupPermissionsSettings_1GKbF9 @include(if: $isM3GroupPermsEnabled)\n}\n\nfragment DefaultGoalAccessLevelSection_1GKbF9 on Query {\n  goals_appSettings(containerId: $containerId) @optIn(to: \"Townsquare\") {\n    defaultGoalAccessLevel\n  }\n}\n\nfragment GoalGroupPermissionsSettings_1GKbF9 on Query {\n  goals_capabilities(containerId: $containerId) {\n    canRemoveAppLevelPermissions\n  }\n  goals_appPermissionPolicies(containerId: $containerId, first: 100) @optIn(to: \"Townsquare\") {\n    edges {\n      node {\n        id\n        scopedGroupId\n        group {\n          name\n          id\n        }\n        isDefaultGroup\n        isEditable\n        userCount\n        productRoles {\n          role\n        }\n        appPermissions {\n          permission\n          isPermitted\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b6d8d8d6967adc1e5e51ceeb72ab3979";

export default node;
